<template>
  <div class="usc-linkGroup gutter-lg">
    <h2>{{title}}</h2>
    <ul>
      <li v-for="(link, index) in links">
        <a :href="link.url" target="_blank">
          <div class="usc-linkGroup__link-text">
            {{link.text}}
          </div>
          <div class="usc-linkGroup__arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13">
              <path fill="#231F20" d="M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"/>
            </svg>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LinkGroup',
  props: ['links', 'title'],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .usc-linkGroup {
    h2 {
      margin-bottom: 30px;
    }
    ul {
      font-size: 15px;
      font-family: $fNational;
      font-style: italic;
      line-height: 1.6;
    }
    li:first-child {
      border-top: 1px solid $cBorder;
    }
    li {
      border-bottom: 1px solid $cBorder;
      display: block;
    }
    svg {
      width: 7px;
      height: 13px;
    }
    a {
      padding: 18px 0;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      color: $cBody;
      text-decoration: none;
      border-left: 3px solid transparent;
      transition: all .2s ease;
      &:hover {
        color: $cMaroon;
        border-left: 3px solid $cMaroon;
        transition: all .2s ease;
        & svg path {
          fill: $cMaroon;
        }
        & .usc-linkGroup__link-text {
          padding-left: 18px;
          transition: all .2s ease;
        }
      }
      .usc-linkGroup__link-text {
        padding-left: 0;
        transition: all .2s ease;
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/LinkGroup.vue